import { render } from "./ui-message.vue?vue&type=template&id=1cbdaf1c"
import script from "./ui-message.vue?vue&type=script&lang=js"
export * from "./ui-message.vue?vue&type=script&lang=js"

import "./ui-message.vue?vue&type=style&index=0&id=1cbdaf1c&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__